const eventFilterNames = Object.freeze({
    nameFilter: "eventname",
    includeTypeFilter: "eventtypeid",
    excludeTypeFilter: "eventtypeid",
    includeStatusFilter: "statusid",
    excludeStatusFilter: "statusid",
    targetFilter: "participantid",
    locationStateFilter: "locationstate",
    officeStateFilter: "officestate",
    officeTypeFilter: "officetypeid",
    trackerFilter: "eventtracker",
    hasNoTrackersFilter: "eventhastrackers",
    rangeStartFilter: "eventendafter",
    rangeEndFilter: "eventstartbefore",
    reportedRangeStartFilter: "eventreportedafter",
    reportedRangeEndFilter: "eventreportedbefore"
});

export default eventFilterNames;



//////////////////
// WEBPACK FOOTER
// ./src/models/EventFilterNames.js
// module id = 2BY0
// module chunks = 1